import { Component, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClimatePulseService } from '../services/climate-pulse.service';
import { OverlayLockService } from '../services/overlay-lock.service';
import { BreakyComponent } from '../shared/components/breaky/breaky.component';
import { BreakyPose } from '../shared/breaky/breaky-poses';

interface Face {
  value: number;
  emoji: string;
  label: string;
}

@Component({
  selector: 'app-climate-pulse-modal',
  standalone: true,
  imports: [CommonModule, BreakyComponent],
  templateUrl: './climate-pulse-modal.component.html',
  styleUrls: ['./climate-pulse-modal.component.css']
})
export class ClimatePulseModalComponent {
  private readonly pulse = inject(ClimatePulseService);
  // Overlay a pantalla completa: sin esto la barra superior lo tapa.
  private readonly overlayHold = inject(OverlayLockService).hold(inject(DestroyRef));

  readonly question$ = this.pulse.question$;
  readonly privacyNote =
    this.pulse.privacyNote ||
    '100% anónima: tu respuesta no se asocia a tu nombre. Tu empresa solo ve promedios de áreas con al menos 5 respuestas.';

  readonly faces: Face[] = [
    { value: 1, emoji: '😞', label: 'Nada' },
    { value: 2, emoji: '😕', label: 'Poco' },
    { value: 3, emoji: '😐', label: 'Regular' },
    { value: 4, emoji: '🙂', label: 'Bastante' },
    { value: 5, emoji: '😄', label: 'Totalmente' }
  ];

  selected: number | null = null;
  sending = false;
  thanks = false;
  error = false;

  get pose(): BreakyPose {
    return this.thanks ? 'happy' : 'wave';
  }

  async send(): Promise<void> {
    if (!this.selected || this.sending) return;
    this.sending = true;
    this.error = false;
    try {
      await this.pulse.answer(this.selected);
      this.thanks = true;
      setTimeout(() => this.pulse.dismiss(false), 1600);
    } catch {
      this.error = true;
    } finally {
      this.sending = false;
    }
  }

  skip(): void {
    this.pulse.dismiss(true);
  }
}
